module.exports = __webpack_public_path__ + "img/Alexa-Barron.60f8be11.jpg";